import angular from 'angular';
import forgotUsernameTpl from './forgot-username.html';
import forgotUsernameModalTpl from './views/forgot-username-modal.html';

const mapStateToThis = ({ config }) => {
  const { phoneMask, phoneLength } = config;

  return {
    phoneMask,
    phoneLength,
  };
};

@Inject('$ngRedux', 'Notifications', '$state')
class ForgotUsernameController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
    this.initializeConfiguration();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initializeConfiguration() {
    this.formModel = {};
  }

  forgotUsernameHandler(form) {
    form.$setSubmitted();

    if (form.$invalid) return;

    this.api.remindUsername
      .run(this.formModel)
      .then(() => this.Notifications.showComplexDialog({
        template: forgotUsernameModalTpl,
      }).result.then(() => {
        this.$state.go('home-view');
      }))
      .catch(() => {
        this.formModel = {};
        this.$state.reload();
      });
  }
}

class ForgotUsernameComponent {
  constructor() {
    this.template = forgotUsernameTpl;
    this.controller = ForgotUsernameController;
    this.bindings = {
      model: '<',
      api: '<',
    };
    return this;
  }
}

export default angular.module('forgot-username', []).component('forgotUsername', new ForgotUsernameComponent());



// WEBPACK FOOTER //
// ./src/modules/auth/components/forgot-username/forgot-username-component.js